import { ComponentFactory } from './factory';
/**
 * 存放所有已注册的组件
 */

var ComponentsStorage = new Map();
/**
 * 组件管理器
 *
 * 用于管理注册的所有组件类
 */

var ComponentsManager = function () {
  function ComponentsManager() {}
  /**
   * 注册组件类
   *
   * @param name 组件名称
   * @param component 组件类
   */


  ComponentsManager.register = function (name, component) {
    if (ComponentsStorage.has(name)) {
      throw new Error("Component " + name + " is registered.");
    }

    var reactComponent;

    if (typeof component === 'object') {
      var dynamicComponent = ComponentFactory(name, component);

      if (!dynamicComponent) {
        return;
      }

      reactComponent = dynamicComponent;
    } else {
      reactComponent = component; // @ts-ignore

      reactComponent.displayName = '#' + (component.displayName || component.name);
    }

    ComponentsStorage.set(name, reactComponent);
  };
  /**
   * 检查指定名称的组件是否已注册
   *
   * @param name 名称
   */


  ComponentsManager.has = function (name) {
    return ComponentsStorage.has(name);
  };
  /**
   * 获取组件类
   *
   * @param name 名称
   */


  ComponentsManager.get = function (name) {
    if (!ComponentsStorage.has(name)) {
      throw new Error("Component " + name + " not found.");
    }

    return ComponentsStorage.get(name);
  };

  return ComponentsManager;
}();

export { ComponentsManager };